export const FETCH_QUICK_RATES_SUCCESS = 'FETCH_QUICK_RATES_SUCCESS';
export const FETCH_QUICK_RATES_REQUEST = 'FETCH_QUICK_RATES_REQUEST';
export const FETCH_QUICK_RATES_FAILURE = 'FETCH_QUICK_RATES_FAILURE';
export const FETCH_QUICK_RATES_RESET = 'FETCH_QUICK_RATES_RESET';
export const fetchQuickRatesSuccess = (payload) => ({
    type: FETCH_QUICK_RATES_SUCCESS,
    payload,
});
export const fetchQuickRatesRequest = (payload) => ({
    type: FETCH_QUICK_RATES_REQUEST,
    payload,
});
export const fetchQuickRatesFailure = (error) => ({
    type: FETCH_QUICK_RATES_FAILURE,
    payload: {
        message: error.message
    },
});
export const fetchQuickRatesReset = () => ({
    type: FETCH_QUICK_RATES_RESET,
});
